import styled from "styled-components";

export const Container = styled.div`
  display: flex;

  label {
    padding-left: 6px;
    cursor: pointer;
  }
  
  input {
    margin-right: 0 !important;
    cursor: pointer;
  }
`;
